// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"fe4b07bc","185":"ef39598f","507":"c0bb166a","646":"40491358","726":"36e5a991","878":"8ca459bd","998":"32c314e4"}[chunkId] + ".chunk.js";
};